/**
 * @generated SignedSource<<eff4bd6e6d31827291dcb908847286bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PromotionPageDeleteInput = {
  promotionId: string;
};
export type PromotionId_promotionPageDeleteMutation$variables = {
  input: PromotionPageDeleteInput;
};
export type PromotionId_promotionPageDeleteMutation$data = {
  readonly promotionPageDelete: {
    readonly __typename: "PromotionPage";
  };
};
export type PromotionId_promotionPageDeleteMutation = {
  response: PromotionId_promotionPageDeleteMutation$data;
  variables: PromotionId_promotionPageDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PromotionPage",
    "kind": "LinkedField",
    "name": "promotionPageDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionId_promotionPageDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionId_promotionPageDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cbd997612e2f80a22a099a805f28f144",
    "id": null,
    "metadata": {},
    "name": "PromotionId_promotionPageDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PromotionId_promotionPageDeleteMutation(\n  $input: PromotionPageDeleteInput!\n) {\n  promotionPageDelete(input: $input) {\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e68834af88075fb24affca6410e235d";

export default node;
